import React from 'react';
import { Box, Paper, Typography, Chip, Stack, Divider } from '@mui/material';
import { WorkspacePremium as PremiumIcon } from '@mui/icons-material';

/**
 * Premium Hospital Claims — PLACEHOLDER
 * ----------------------------------------------------------------------------
 * The redesigned Claims interface goes here. This file exists now so the whole
 * licensing path can be built and tested end to end before a single screen is
 * designed:
 *
 *     central DB licence  →  /claimsEdition  →  Claims.js picks a component
 *
 * If you are seeing this screen in the app, everything upstream is working —
 * the facility is licensed AND has selected Premium. Replace the body of this
 * component with the real interface; nothing else needs to change.
 *
 * Keep the default export and the file name, or update the import in
 * Claims/Claims.js to match.
 */
export default function HospitalClaimsPremium() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Paper
        variant="outlined"
        sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, maxWidth: 780, mx: 'auto', mt: { xs: 2, md: 6 } }}
      >
        <Stack spacing={2.5} alignItems="flex-start">
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 44, height: 44, borderRadius: 2,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                bgcolor: 'rgba(109, 40, 217, 0.12)', color: '#6d28d9',
              }}
            >
              <PremiumIcon />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                Premium Claims
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Licensed to this facility
              </Typography>
            </Box>
            <Chip label="ACTIVE" color="success" size="small" sx={{ fontWeight: 700, ml: 1 }} />
          </Stack>

          <Divider flexItem />

          <Typography variant="body1" color="text.secondary">
            This is the placeholder for the new Claims interface. The licensing
            path is wired and working — the facility is licensed and has selected
            Premium, which is why this screen opened instead of the standard one.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            The redesigned form and its rules will be built here. To go back to
            the standard Claims screen at any time, use{' '}
            <strong>System Settings → Claims Interface</strong> and switch the
            selection to Standard.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
